import { render, staticRenderFns } from "./AffairDialog.vue?vue&type=template&id=420e2254"
import script from "./AffairDialog.vue?vue&type=script&lang=js"
export * from "./AffairDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports